import { trackActions } from '../../tracking/trackingScripts'
import { TRACKED_ACTIONS } from '../actions/types'

export const trackingMiddleware = (store) => (next) => (action) => {
  const { type } = action
  if (TRACKED_ACTIONS[type]) {
    trackActions(action)
  }
  return next(action)
}
